import { TAnswer } from '../../types/answers';
import { ITypedArrayObject } from '../../types/mappers/array';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { EStatus } from '../../types/likes';

export enum EAnswersActionTypes {
  SetAnswers = 'ANSWERS/SET_ANSWERS',
  SetAnswerReaction = 'ANSWERS/SET_ANSWER_REACTION',
}

export type TSetAnswersPayload = ITypedArrayObject<TAnswer, 'string'>['byId'];
export type TSetAnswers = ITypedReduxAction<EAnswersActionTypes.SetAnswers, TSetAnswersPayload>;

export type TSetAnswerReactionPayload = {
  answerId: string;
  type: EStatus;
};
export type TSetAnswerReaction = ITypedReduxAction<EAnswersActionTypes.SetAnswerReaction, TSetAnswerReactionPayload>;

export type TAnswersActions = TSetAnswers | TSetAnswerReaction;
